import React, { useMemo, useState } from "react";
import { MoneyExExpressOrders } from "../../../pages";
import { encodeQueryData } from "../../../utils/utils";
import { MoneyExController } from "../../../controllers";

const MoneyExExpressOrdersContainer = () => {
  const modalConstants = {
    Close: "CLOSE",
    ViewBuyerInfo: "View Buyer Info",
    VerifyBuyerPayment: "Verify Buyer Payment",
    UpdateBuyerPayment: "Update Buyer Payment",
    RefundBuyerPayment: "Refund Buyer Payment",
  };

  const [limit, setLimit] = useState(50);
  // const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [openModal, setOpenModal] = useState(modalConstants.Close);
  const [singleItem, setsingleItem] = useState({});

  const openModalHandler = (item) => {
    setOpenModal(item);
  };
  const closeModal = () => {
    setOpenModal(modalConstants.Close);
  };

  const options = (buyerStatus, adminBuyerPaymentStatus, status) => {
    const options = [
      {
        label: modalConstants.ViewBuyerInfo,
        value: modalConstants.ViewBuyerInfo,
      },
    ];

    if (
      buyerStatus !== "FALSE-PAYMENT" &&
      buyerStatus !== "PAID" &&
      buyerStatus !== "REVERSED"
    ) {
      options.push({
        label: modalConstants.VerifyBuyerPayment,
        value: modalConstants.VerifyBuyerPayment,
      });
    }

    if (
      adminBuyerPaymentStatus === "AWAITING" &&
      buyerStatus !== "FALSE-PAYMENT"
    ) {
      options.push({
        label: modalConstants.UpdateBuyerPayment,
        value: modalConstants.UpdateBuyerPayment,
      });
    }

    if (
      status !== "COMPLETED" &&
      buyerStatus !== "REVERSED" &&
      buyerStatus !== "FALSE-PAYMENT"
    ) {
      options.push({
        label: modalConstants.RefundBuyerPayment,
        value: modalConstants.RefundBuyerPayment,
      });
    }

    return options;
  };

  const optionHandler = (option, item) => {
    setsingleItem(item);
    openModalHandler(option.value);
  };

  const query = useMemo(() => {
    return {
      ...(searchQuery ? { search: searchQuery } : {}),
      limit: limit,
      offset: currentPage,
    };
  }, [searchQuery, limit, currentPage]);

  const encodeP2PQuery = encodeQueryData({
    ...query,
  });

  const { isLoading, data, isFetching } =
    MoneyExController.useGetExpressOrders(encodeP2PQuery);

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  return (
    <MoneyExExpressOrders
      onLimitChange={onLimitChange}
      data={data}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      limit={limit}
      isLoading={isLoading}
      isFetching={isFetching}
      setSearchQuery={setSearchQuery}
      openModal={openModal}
      optionHandler={optionHandler}
      closeModal={closeModal}
      modalConstants={modalConstants}
      singleItem={singleItem}
      options={options}
    />
  );
};

export default MoneyExExpressOrdersContainer;
